import { useDAppCommand } from "../../libs/dweb/DAppCommand";
import { DBasePage } from "../../libs/dweb/DBasePage";
import { DButton } from "../../libs/dweb/DButton";
import { DForm, TFormDataModel } from "../../libs/dweb/DForm";
import { DRow } from "../../libs/dweb/DRow";
import { DTable } from "../../libs/dweb/DTable";
import { DText } from "../../libs/dweb/DText";
import { TAccountEntry, useMoney } from "../models/Hook";
import { DCol } from "../../libs/dweb/DCol";
import { useState } from "react";
import { DSpace } from "../../libs/dweb/DSpace";
import { DTextDashboard } from "../../libs/dweb/DTextDashboard";
import { DTwoPaneView } from "../../libs/dweb/DTwoPaneView";
import { dcolors, dlog } from "corexxx";
import { CommonTS } from "../../libs/common_ts/corexxx-ext";
import { DRadioButton } from "../../libs/dweb/DRadioButton";
import { DSwitchInput } from "../../libs/dweb/DSwitchInput";
import { DRefreshButton } from "../../libs/dweb/DRefreshButton";
import React from "react";
import { DWebTS } from "../../libs/common_ts/DWebTS";
import { DAlternativeScreen, DAlternativeScreenHolder } from "../../libs/dweb/DAlternativeScreen";
import { DImport } from "../../libs/dweb/DImport";
import { DTextOr } from "../../libs/dweb/DTextOr";
import { text } from "stream/consumers";
import { DSelectInput } from "../../libs/dweb/DSelectInput";
import { DPageHeader } from "../../libs/dweb/DPageHeader";

// Model
const accountEntryModel: TFormDataModel = {
  data: [
    {
      required: true,
      type: "select",
      name: "investment_type",
      options_list: [
        "FIXED_DEPOSIT",
        "ISA",
        "REAL_ESTATE",
        "SAVING_ACCOUNT",
        "TRADING_ACCOUNT",
        "RETIREMENT",
        "MORTGAGE",
      ],
    },
    { type: "input", name: "acccount_id", required: true },
    { type: "input", name: "banker_name", required: true },
    { type: "number", name: "priciple_account", required: true },
    {
      type: "select",
      name: "state",
      options_list: ["ACTIVE", "MATURED", "REPLACTED"],
      required: true,
      default: "ACTIVE",
    },

    { type: "input", name: "start_date", label: "start Date(dd/mm/yyy)" },
    { type: "number", name: "interest_rate", required: true },
    { type: "number", name: "maturity_amount" },
    { type: "input", name: "maturity_date", label: "maturity date(dd/mm/yyy)" },
    {
      type: "select",
      name: "currency",
      options_list: ["INR", "GBP", "USD"],
      required: true,
      default: "GBP",
    },
    { type: "input", name: "comments" },
  ],
};

export function NetWorthView() {
  // Preview
  const [previewList, setPreviewList] = useState<TAccountEntry[]>([]);
  return (
    <DBasePage
      style={{ padding: 0, height: "calc(100vh - 100px)" }}
      fullwidth={true}
    >
      <DTwoPaneView
        width={600}
        left={
          <LeftView
            onChangePreViewList={(list: TAccountEntry[]) => {
              setPreviewList(list);
            }}
          />
        }
        right={<RightView previewList={previewList} />}
      />
    </DBasePage>
  );
}
function processObj(obj: any): TAccountEntry {
  let res: TAccountEntry = {
    acccount_id: obj.acccount_id,
    investment_type: obj.investment_type,
    banker_name: obj.banker_name,
    priciple_account: obj.priciple_account,
    maturity_amount: obj.maturity_amount,
    currency: obj.currency,
    start_date:
      (obj.start_date?.length || 0) > 0
        ? CommonTS.convertDateToISO(obj.start_date)
        : "",
    maturity_date:
      (obj.maturity_date?.length || 0) > 0
        ? CommonTS.convertDateToISO(obj.maturity_date)
        : "",
    interest_rate: obj.interest_rate,
    comments: obj.comments,
    state: obj.state,
  };
  return res;
}

// LEFT VIEW
function LeftView({
  onChangePreViewList,
}: {
  onChangePreViewList: (list: TAccountEntry[]) => void;
}) {
  let moneyComamnd = useMoney();
  let [addType, setAddType] = useState("one");

  const [previewList, setPreviewList] = useState<TAccountEntry[]>([]);
  return (
    <DCol>
      <DSelectInput value={addType} onChange={setAddType} options={[{ value: "one" }, { value: "import" }]} />
      <DAlternativeScreenHolder activescreen={addType}>
        <DAlternativeScreen name="one">
          <DForm
            model={accountEntryModel}
            onSubmit={(obj) => {
              setPreviewList([processObj(obj)]);
            }}
            config={{
              title: "Add new Account Entry",
              submit_btn_text: "See Preview",
            }}
          />
        </DAlternativeScreen>
        <DAlternativeScreen name="import">
          <DImport onProgress={async (objList) => {
            const data = objList.map(x => processObj(x))

            setPreviewList(data);
          }} />
        </DAlternativeScreen>

      </DAlternativeScreenHolder>
      <DTextOr text="Preview" />
      <Table1 data={previewList} />


      <DRow style={{ marginTop: 20 }}>
        <DSpace />
        <DButton
          style={{ marginRight: 10 }}
          text="Show Net Worth With Preview"
          onClick={() => {
            onChangePreViewList([...previewList]);
          }}
        ></DButton>
        <DButton
          style={{ marginRight: 10 }}
          text="Clear Perview Table"
          onClick={() => {
            setPreviewList([]);
          }}
        ></DButton>
        <DSpace />
        <DButton
          style={{ marginRight: 0 }}
          text="Commit Changes"
          onClick={async () => {
            for (let i = 0; i < previewList.length; i++) {
              await moneyComamnd.api.addAccountEntry(
                previewList[i] as TAccountEntry,
              );
            }
          }}
        ></DButton>
      </DRow>
    </DCol>
  );
}

// RIGHT VIEW
function RightView({ previewList }: { previewList: TAccountEntry[] }) {
  let appComamnd = useDAppCommand();
  let moneyComamnd = useMoney();
  let account = moneyComamnd.state.accountSummary;

  function getFormetedValue(value: number): string {
    return DWebTS.getCurrencySymbol(
      appComamnd.accountState?.currency || "GBP",
    ) +
      CommonTS.formatNumberWithCommas(value)
  }

  React.useEffect(() => {
    moneyComamnd.api.addPreviewList(previewList);
  }, [previewList]);

  const [title, setTitle] = useState("Summary");
  return (
    <DCol id="print-area">
      <DCol>
        <DRow
          style={{
            background: dcolors.pallets.red700,
            padding: 10,
            marginBottom: 10,
          }}
          center
        >
          <DText dark style={{ fontWeight: "bold", fontSize: 22 }}>
            Welcome {appComamnd.accountState?.name}!
          </DText>
          <DSpace />
          <DSelectInput
            dark
            style={{ top: 5 }}
            value={title}
            onChange={setTitle}
            options={[
              { value: "Summary" },
              { 'value': 'Contributed List' },
              { value: "Predictions" },
              { value: "Log Entried" },
            ]}
          />

          <DRefreshButton
            dark
            onClick={moneyComamnd.api.refreshAccountSummary}
          />
          <DButton text="Print Report" onClick={printComponent} />
        </DRow>

        {title == "Log Entried" ? (
          <Table1 data={moneyComamnd.state.rawEntry} />
        ) : null}

        {title == "Contributed List" && account.contributed_data ? (
          <>
            <DPageHeader
              title="Contibuted Datapoints"
              rightView={<DButton text="Verify" onClick={() => { moneyComamnd.api.verifyAndFix() }} />}
            />
            <DTable
              data={account.contributed_data}
              columns={[
                { field: 'ts_insert', view_type: 'datetime' },
                { field: "investment_type" },
                { field: "banker_name" },
                { field: "acccount_id" },
                {
                  field: "priciple_account",
                  format: (x) =>
                    appComamnd.state.textPrivacyState
                      ? "****"
                      : DWebTS.getCurrencySymbol(
                        appComamnd.accountState?.currency || "GBP",
                      ) + CommonTS.formatNumberWithCommas(x),
                },
                { field: 'maturity_date', view_type: 'datetime' },
                { field: 'maturity_date', format: (x) => DWebTS.daysLeftUntilDate(x) == '' ? '-' : DWebTS.daysLeftUntilDate(x) + ' days to go' }
              ]}
            /></>
        ) : null}

        {title == "Summary" ? (
          <DCol>
            <DTextDashboard
              style={{ marginBottom: 10, textAlign: "center" }}
              item={[
                {
                  text: "Your Net Worth",
                  value:
                    DWebTS.getCurrencySymbol(
                      appComamnd.accountState?.currency || "GBP",
                    ) +
                    CommonTS.formatNumberWithCommas(
                      account.distribution1.total_asserts -
                      account.distribution1.total_liabilities,
                    ),
                  sub_text: CommonTS.numberToWords(
                    account.distribution1.total_asserts -
                    account.distribution1.total_liabilities,
                  ),
                },
              ]}
            />
            <DTextDashboard
              item={[
                {
                  text: "Total Asserts",
                  value:
                    DWebTS.getCurrencySymbol(
                      appComamnd.accountState?.currency || "GBP",
                    ) +
                    CommonTS.formatNumberWithCommas(
                      account.distribution1.total_asserts,
                    ),
                  sub_text:
                    "Includes everything, Saving, ISA, retairment, stocks, real estate",
                },
                {
                  text: "Total Liabilities",
                  value:
                    DWebTS.getCurrencySymbol(
                      appComamnd.accountState?.currency || "GBP",
                    ) +
                    CommonTS.formatNumberWithCommas(
                      account.distribution1.total_liabilities,
                    ),
                  sub_text:
                    (
                      (account.distribution1.total_liabilities /
                        (account.distribution1.total_asserts || 1)) *
                      100
                    ).toFixed(2) + "% of Income",
                },
                {
                  text: "Net Worth",
                  value:
                    DWebTS.getCurrencySymbol(
                      appComamnd.accountState?.currency || "GBP",
                    ) +
                    CommonTS.formatNumberWithCommas(
                      account.distribution1.total_asserts -
                      account.distribution1.total_liabilities,
                    ),
                  sub_text:
                    (
                      ((account.distribution1.total_asserts -
                        account.distribution1.total_liabilities) /
                        (account.distribution1.total_asserts || 1)) *
                      100
                    ).toFixed(2) + "% of Income",
                },
              ]}
            />
            <DText>Asserts Distribution</DText>
            <DTextDashboard
              style={{ marginBottom: 10, textAlign: "center" }}
              item={[
                {
                  text: "Your Net Worth",
                  value:
                    DWebTS.getCurrencySymbol(
                      appComamnd.accountState?.currency || "GBP",
                    ) +
                    CommonTS.formatNumberWithCommas(
                      account.distribution1.total_asserts -
                      account.distribution1.total_liabilities,
                    ),
                  sub_text: CommonTS.numberToWords(
                    account.distribution1.total_asserts -
                    account.distribution1.total_liabilities,
                  ),
                },
              ]}
            />
            <DText>Distribution By Institutions</DText>
            {account.distribution3 ? <DTextDashboard
              itemStyle={{ marginBottom: 10, padding: 5, fontSize: 20 }}
              style={{ margin: 10, textAlign: "center" }}
              item={Object.values(account.distribution3).map(x => ({
                text: x.name as string,
                value: getFormetedValue(Object.values(x.investment).reduce((total: any, num) => total + num, 0) as number),
                sub_text: Object.entries(x.investment)
                  .map(([key, value]) => `${key} is ${getFormetedValue(value as number)}`)
                  .join(", ")
              }))}
            /> : null}
          </DCol>
        ) : null}
      </DCol>
    </DCol>
  );
}

// Table
function Table1({ data }: { data: any[] }) {
  console.log("Rendering table1");
  return (
    <DTable
      height={"100%"}
      data={data}
      columns={[
        {
          field: "_id",
          format: (x) => "..." + x?.substring(0, 5),
        },
        {
          field: "investment_type",
        },
        {
          field: "acccount_id",
        },
        {
          field: "banker_name",
        },
        {
          field: "priciple_account",
        },
        {
          field: "currency",
        },
        {
          field: "ts_insert",
          headerName: "Record Date",
          format: (x) => isoToDDMMYYYY(x),
        },
        {
          field: "state",
        },
        {
          field: "interest_rate",
        },
        {
          field: "maturity_amount",
        },
        {
          field: "start_date",
          format: (x) => isoToDDMMYYYY(x),
        },
        {
          field: "maturity_date",
          format: (x) => isoToDDMMYYYY(x),
        },
        {
          field: "maturity_amount",
        },
        {
          field: "comments",
        },
      ]}
    />
  );
}

const printComponent = () => {
  // Save the current page content

  const originalContents = document.body.innerHTML;

  // Replace the body content with the printable area
  // @ts-ignore
  const printContents = document.getElementById("print-area").innerHTML;
  document.body.innerHTML = printContents;

  // Trigger the print dialog
  window.print();

  // Restore the original content after printing or canceling
  //document.body.innerHTML = originalContents;
  console.log("Once you print, the page will be loaded again");
};

function isoToDDMMYYYY(isoDate: string) {
  try {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch (e) {
    return "-";
  }
}
